import { useEffect } from 'react';
/**
 * Hook that listens to keyboard `Enter` press to execute `onEnter`.
 *
 * @param isValid - boolean for whether pressing `Enter` will execute `onEnter` function
 * @param onEnter - callback to execute on pressing `Enter`
 */
function useOnEnterHandler(isValid, onEnter) {
    useEffect(function () {
        var cb = function (event) {
            if (!isValid)
                return;
            if (event.key === 'Enter')
                onEnter();
        };
        document.addEventListener('keyup', cb);
        return function () {
            document.removeEventListener('keyup', cb);
        };
    }, [isValid, onEnter]);
}
export default useOnEnterHandler;
